/**
 * this is world-around for the fact that
 * ReactiveMap does not have the isEqual method
 * available to createSignal.
 */
export default function syncMapToReactiveMap<T, V>(
  map1: Map<T, Array<V>>,
  map2: Map<T, Array<V>>,
  isListEquals: (a: Array<V>, b: Array<V>) => boolean,
): void {
  for (const [key, list1] of map1) {
    const list2 = map2.get(key)
    if (!list2 || !isListEquals(list1, list2)) {
      map2.set(key, list1)
    }
  }

  for (const key of map2.keys()) {
    if (!map1.has(key)) {
      map2.delete(key)
    }
  }
}